import React from "react";
import BaseControler from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "./../Global/NanoFlex";
import CardBlock from "./../Nano/CardBlock.js";
import ViewMore from "./../Nano/ViewMore.js";
import TitleCard from "./../Nano/TitleCard.js";
import Grid from "./../Macro/Grid.js";

const multiple = nota.global.multiple;
let setIntervalScope = null;

const DotsIndicator = (props) => (!props.indicatorList ? null : props.indicatorList.map((bool, i) => <div className={bool ? "dot selected" : "dot"} key={i} />));

const StyledMainCarrosel = styled(NanoFlex)`
  width: 100%;
  .mainCarroselWrapper {
    border: 1px solid ${nota.color.main.default};
    border-top: 3px solid ${nota.color.main.default};
    margin: ${multiple + "px"}; /* 8px */
    padding: ${multiple + "px"}; /*8px*/
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    position: relative;

    .gridsWrapper {
      .halfGrid {
        width: 130%;
        align-self: flex-start;

        .cardBlock {
          min-height: auto;
          .cardBlockWrapper {
            padding: 4px 0px;
            min-height: auto;
          }
        }
        .grid {
          grid-template-columns: repeat(auto-fill, minmax(251px, 1fr));
        }
        @media only screen and (max-width: ${nota.global.breakpoints.smallDesktop + "px"}) {
          width: 85%;
        }
        @media only screen and (max-width: ${nota.global.breakpoints.laptop + "px"}) {
          width: 95%;

          .grid {
            grid-template-columns: repeat(auto-fill, minmax(232px, 1fr));
          }
        }
        @media only screen and (max-width: 1500px) {
          .grid {
            grid-template-columns: repeat(auto-fill, minmax(221px, 1fr));
          }
        }

        @media only screen and (max-width: ${nota.global.breakpoints.smallLaptop + "px"}) {
          width: calc(100% - 56%);
          .grid {
            grid-template-columns: repeat(auto-fill, minmax(195px, 1fr));
          }
        }
        @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
          width: calc(100% - 56%);
        }
      }
      .bigImageHalf {
        margin-right: ${multiple + "px"};
        align-self: flex-start;
        display: contents;
        min-width: 0;
        .cardBlock {
          width: 100%;
          min-width: 0;
          .performanceWrapper {
            transform: scale(2);
            right: 8px;
            bottom: 8px;
          }
          .cardBlockWrapper {
            min-height: 60px;
            padding: 8px 0px;
            background-color: ${nota.color.neutral.NeuFour};
            padding: ${multiple + "px"};
            justify-content: center;
            min-width: 0;
          }
        }
        @media only screen and (max-width: ${nota.global.breakpoints.smallLaptop + "px"}) {
          width: 50%;
        }
      }
    }
  }

  .indicator {
    .dot {
      border-radius: 6px;
      border: 1px solid ${nota.color.main.default};
      padding: 6px;
      margin: 12px;
    }
    .selected {
      background-color: ${nota.color.main.default};
    }
  }
`;

class MainCarrosel extends BaseControler {
  constructor(props) {
    super(props);

    const totalDataLength = window.innerWidth < nota.global.breakpoints.laptop ? 5 : 7;

    this.state = {
      currentData: this.filterInitialCurrentData(this.props.data, totalDataLength),
      indicator: this.initialIndicatorState(totalDataLength),
      totalDataLength: totalDataLength,
    };

    this.isHover = false;
  }

  componentDidMount() {
    super.componentDidMount();

    const seconds = this.props.seconds ? this.props.seconds * 1000 : 5 * 1000;
    setIntervalScope = setInterval(this.carroselLoop, seconds);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        currentData: this.filterInitialCurrentData(this.props.data, this.state.totalDataLength),
      });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();

    clearInterval(setIntervalScope);
  }

  filterInitialCurrentData = (data, totalDataLength) => {
    return [...data].filter((v, i) => i < totalDataLength);
  };

  initialIndicatorState = (totalDataLength) => {
    let output = new Array(totalDataLength).fill(false);
    output[0] = true;
    return output;
  };

  carroselLoop = () => {
    if (this.isHover === false) {
      this.setState({
        currentData: this.loopItSelf(this.state.currentData),
        indicator: this.loopItSelf(this.state.indicator),
      });
    }
  };

  loopItSelf = (arr) => {
    let arrayCopy = [...arr];
    const withoutTheLast = arrayCopy.filter((v, i) => i !== arrayCopy.length - 1);
    const output = [arrayCopy[arrayCopy.length - 1], ...withoutTheLast];

    return output;
  };

  resizeAction = () => {
    const output = window.innerWidth < nota.global.breakpoints.laptop ? 5 : 7;

    if (this.state.totalDataLength !== output) {
      this.setState({
        currentData: this.filterInitialCurrentData(this.props.data, output),
        indicator: this.initialIndicatorState(output),
        totalDataLength: output,
      });
    }
  };

  onMouseOver = () => {
    this.isHover = true;
  };

  onMouseLeave = () => {
    this.isHover = false;
  };

  render() {
    const firstDataObj = this.state.currentData[0];
    const rightDataArray = [...this.state.currentData].filter((v, i) => i !== 0);

    return (
      <StyledMainCarrosel onMouseOver={this.onMouseOver} onMouseLeave={this.onMouseLeave}>
        <NanoFlex className="mainCarroselWrapper" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <ViewMore
            onClick={() => {
              window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "NotaSelection" } }));
            }}
          />
          <TitleCard title={this.translation.home.vip.title} secTitle={this.translation.home.vip.secTitle} />
          <NanoFlex className="gridsWrapper" justifyContent="flex-start" alignItems="stretch">
            <NanoFlex className="halfGrid bigImageHalf">
              {firstDataObj && (
                <CardBlock
                  id={firstDataObj.idProgram}
                  title={firstDataObj.localTitle}
                  countryAndChannel={firstDataObj.country === null || firstDataObj.channel === null ? null : `${firstDataObj.country} - ${firstDataObj.channel}`}
                  date={firstDataObj.date}
                  image={firstDataObj.image}
                  performanceColor={firstDataObj.premiereColor}
                  size={"m"}
                />
              )}
            </NanoFlex>
            <NanoFlex className="halfGrid">
              <Grid data={rightDataArray} row={2} bubbleUpResizeAction={this.resizeAction} />
            </NanoFlex>
          </NanoFlex>

          {this.props.indicator && (
            <NanoFlex className="indicator">
              <DotsIndicator indicatorList={this.state.indicator} />
            </NanoFlex>
          )}
        </NanoFlex>
      </StyledMainCarrosel>
    );
  }
}

export default MainCarrosel;

// --- // Documentation // --- //
/*
import MainCarrosel from './../Micro/MainCarrosel.js';

<MainCarrosel seconds={5} />
*/
